import React from "react";

// Status badge styling and text (Active / OnLeave / Inactive / Archived / Unknown)
const StatusBadge = ({ status, screenSize, fonts, text, language }) => {
  // Base styles for all status badges
  const baseStyle = {
    padding: screenSize === "xs" ? "0.25rem 0.5rem" : "0.25rem 0.625rem",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.75rem",
    fontSize: fonts.small,
    fontWeight: "600",
  };

  // Return styled span based on status
  switch (status) {
    case "Active":
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: "#d1fae5",
            color: "#065f46",
          }}
        >
          {text[language].statusActive}
        </span>
      );
    case "OnLeave":
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: "#fef3c7",
            color: "#92400e",
          }}
        >
          {text[language].statusOnLeave}
        </span>
      );
    case "Inactive":
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: "#fee2e2",
            color: "#991b1b",
          }}
        >
          {text[language].statusInactive}
        </span>
      );
    case "Archived":
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: "#e5e7eb",
            color: "#6b7280",
          }}
        >
          {text[language].statusArchived}
        </span>
      );
    default:
      return (
        <span
          style={{
            ...baseStyle,
            backgroundColor: "#e5e7eb",
            color: "#374151",
          }}
        >
          {text[language].statusUnknown}
        </span>
      );
  }
};

export default StatusBadge;
